import { h } from 'preact';
import { ProgressBar } from '../ProgressBar';
import { T } from '../../../styles/tokens';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'ProgressBar',
  category: '📊 Data Display',
  description: 'Barra de progresso com valor, label e cor customizável',
  usedIn: ['Profile', 'ReferralDashboard'],
  example: () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <ProgressBar value={75} label="Upload" />
      <ProgressBar value={30} color={T.danger} label="Erros" />
      <ProgressBar value={100} label="Completo" />
    </div>
  ),
};
